module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-modern_v2-en-67c3edbb10a9ffe9d990e846b50a2222.pdf";